import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.fabricNotebookLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.NotebookActivityLabel),
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.NotebookActivityLabel)
    ]
})
export class FabricNotebookLinkedService extends LinkedService { }
